import script from "./TicketTable.vue?vue&type=script&setup=true&lang=js"
export * from "./TicketTable.vue?vue&type=script&setup=true&lang=js"

import "./TicketTable.vue?vue&type=style&index=0&id=351d0388&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-351d0388"]])

export default __exports__